import { render, staticRenderFns } from "./ClinicAppointments.vue?vue&type=template&id=e3590a3e"
import script from "./ClinicAppointments.vue?vue&type=script&lang=js"
export * from "./ClinicAppointments.vue?vue&type=script&lang=js"
import style0 from "./ClinicAppointments.vue?vue&type=style&index=0&id=e3590a3e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports